import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

import type { BidsAndOffersLinkLocation } from './bulkBiddingEvents.const';

const { BULK_BIDDING } = ANALYTICS_CATEGORIES;
const { CLICK } = SNOWPLOW_EVENTS;

export const triggerBulkBiddingBidsOfferLinkClicked = (linkLocation: BidsAndOffersLinkLocation): void => {
	const eventPayload = getSnowplowEventPayload({
		category: BULK_BIDDING,
		customData: { label: linkLocation },
		name: 'dlr_bulk_bidding_bids_offer_link_clicked',
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
